export const EMPTY_ROUTE_TEMPLATE = "/absdk/test/empty";
export function registerRoute(routeRegistry) {
  return routeRegistry.registerRoute({
    routeTemplate: EMPTY_ROUTE_TEMPLATE,
    routeTitle: "Empty Route, which forces major route unmount",
    view: {
      modulePath: () => import(/* webpackChunkName: "Builtin_Routes" */"abreact/incubator/ui/app/routes/EmptyView"),
      exportName: "EmptyView"
    }
  });
}
//# sourceMappingURL=EmptyRoute.js.map
